import React from 'react'
import AllAssets from '../../components/allAssets/AllAssets'
import "./allAssets.scss"

const AllAssetsPage = () => {
    return (
        <div className='allAssets'>
            {/* <Sidebar /> */}
            <div className="allAssetTables">
                <AllAssets />
            </div>

        </div>
    )
}

export default AllAssetsPage